// extracted by mini-css-extract-plugin
export var cancelButton = "_mr-5";
export var content = "_mr-3";
export var createButton = "_mr-6";
export var drawerContainer = "_mr-0";
export var footer = "_mr-2";
export var header = "_mr-1";
export var orderFormColumn = "_mr-4";